export const DESKTOP_WINDOW_MIN_WIDTH = 280;
export const DESKTOP_WINDOW_MIN_HEIGHT = 120;
/** Reserve at bottom for `.desktop-bottom-bar` (see `workspace-desktop.css` min-height). */
export const DESKTOP_DOCK_HEIGHT = 58;
export const DESKTOP_WINDOW_CASCADE_OFFSET = 30;
/** Reserve the workspace top bar; the workspace canvas starts behind that absolute header. */
export const DESKTOP_WINDOW_TOP_MARGIN = 52;
export const DESKTOP_WINDOW_EDGE_MARGIN = 0;
export const DESKTOP_WINDOW_SNAP_THRESHOLD = 24;
export const DESKTOP_WINDOW_BASE_Z_INDEX = 10;
